export default function startLoading(call) {
    return {
        type: startLoading.type,
        payload: call,
    };
}

startLoading.type = 'START_LOADING';
